/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Overview_Tableofcontents_Documents3Inputs */

const en_coinvestments_overview_tableofcontents_documents3 = /** @type {(inputs: Coinvestments_Overview_Tableofcontents_Documents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Coinvestments_Overview_Tableofcontents_Documents3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_overview_tableofcontents_documents3 = /** @type {((inputs?: Coinvestments_Overview_Tableofcontents_Documents3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Overview_Tableofcontents_Documents3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_overview_tableofcontents_documents3(inputs)
});
export { coinvestments_overview_tableofcontents_documents3 as "coInvestments_overview_tableOfContents_documents" }